import React from 'react';
import { useTranslation } from 'react-i18next';
import { CarStatsCell, StatsDisplayMode } from './CarStatsCell';
import DetailsCard from '@/components/common/DetailsCard';

interface CarStatsProps {
  carId: string;
  mode?: StatsDisplayMode;
}

export const CarStats: React.FC<CarStatsProps> = ({ carId, mode = 'detailed' }) => {
  const { t } = useTranslation();

  return (
    <DetailsCard
      title={t('cars.stats.title')}
    >
      <>
        <CarStatsCell carId={carId} mode={mode} />
      </>
    </DetailsCard>
  );
};
